import React from 'react';
import { FaGlobe, FaChartLine, FaUsers, FaShieldAlt } from 'react-icons/fa';

const ValorDigital = () => {
  const beneficios = [
    {
      icon: <FaGlobe className="text-3xl" />,
      titulo: 'Presença 24 horas',
      descricao: 'Seu negócio visível a qualquer hora, em qualquer lugar. Enquanto você descansa, seu site trabalha por você.',
    },
    {
      icon: <FaChartLine className="text-3xl" />,
      titulo: 'Credibilidade instantânea',
      descricao: 'Um site profissional transmite confiança imediata. Clientes decidem em segundos se confiam na sua marca.',
    },
    {
      icon: <FaUsers className="text-3xl" />,
      titulo: 'Alcance ampliado',
      descricao: 'Supere limites geográficos e conquiste clientes que nunca encontraria apenas com redes sociais.',
    },
    {
      icon: <FaShieldAlt className="text-3xl" />,
      titulo: 'Patrimônio digital',
      descricao: 'Redes sociais são terreno alugado. Seu site é sua sede própria — um ativo que valoriza com o tempo.',
    },
  ];

  return (
    <section
      id="valor-digital"
      className="relative py-32 bg-white dark:bg-dark-surface overflow-hidden transition-colors duration-500"
    >
      <div className="absolute inset-0 opacity-30 dark:opacity-20">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-burnt/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brown/10 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="gsap-reveal-left">
            <p className="text-burnt font-heading font-semibold uppercase tracking-wider text-sm mb-4">
              Por que investir
            </p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-dark dark:text-cream mb-6 leading-tight">
              Um site profissional{' '}
              <span className="text-burnt">valoriza</span> sua empresa
            </h2>
            <p className="text-lg md:text-xl text-dark/70 dark:text-cream/70 leading-relaxed font-body mb-8">
              No mundo digital, sua empresa é julgada antes mesmo do primeiro contato.
              Um site institucional bem construído não é luxo — é a base da sua autoridade online.
            </p>
            <p className="text-lg text-dark/60 dark:text-cream/60 leading-relaxed font-body">
              Transformo ideias em soluções digitais que geram credibilidade, visibilidade
              e oportunidades reais de negócio para empreendedores e empresas.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {beneficios.map((item, index) => (
              <div
                key={index}
                className="gsap-reveal group p-6 rounded-2xl bg-cream dark:bg-dark-bg border border-brown/10 dark:border-burnt/10 hover:border-burnt/30 dark:hover:border-burnt/40 transition-all duration-500 hover:shadow-premium dark:hover:shadow-premium-dark hover:-translate-y-1"
                style={{ transitionDelay: `${index * 0.1}s` }}
              >
                <div className="text-burnt mb-4 group-hover:scale-110 transition-transform duration-300">
                  {item.icon}
                </div>
                <h3 className="text-lg font-heading font-semibold text-dark dark:text-cream mb-2">
                  {item.titulo}
                </h3>
                <p className="text-sm text-dark/70 dark:text-cream/70 leading-relaxed font-body">
                  {item.descricao}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValorDigital;
